/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeNarrowV3Schema } from '../getPublicChallengeBySlugV3/get-public-challenge-by-slug-v3-response';

export const vocabLinkSchema = z.object({
  slug: z.string(),
  title: z.string(),
});

export type IVocabLink = z.infer<typeof vocabLinkSchema>;

export const challengeCollectionCardSchema = z.object({
  slug: z.string(),
  title: z.string(),
  parentTitle: z.string().nullable(),
  posterUrl: z.string().nullable(),
  titleInPoster: z.number().default(0),
  publishedChallengesCount: z.number().default(0),
});

export type IChallengeCollectionCard = z.infer<typeof challengeCollectionCardSchema>;

export const challengeV4Schema = challengeNarrowV3Schema.extend({
  vocabularyLinks: z.record(z.string(), vocabLinkSchema.nullable()),
  collections: z.array(challengeCollectionCardSchema),
});

export type IChallengeV4 = z.infer<typeof challengeV4Schema>;

export const getPublicChallengeBySlugV4ResponseSchema = createApiResponseSchema(
  challengeV4Schema,
) as z.ZodSchema<IAPI<IChallengeV4>>;

export type IGetPublicChallengeBySlugV4Response = IAPI<IChallengeV4>;
